import { Http } from '@/lib/http';

export class ApplicationDataRequirementsService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/settings/application-requirements/';
  }

  createApplicationRequirements() {
    return this.httpClient().post(`${this.endpoint}`);
  }

  getApplicationRequirements() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateApplicationRequirements(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
}
